
export   const products = [
    { 
      id: 62, 
      name: 'LED Bulb', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs.', 
      imageUrls: ['../Assets/LEDbulb/Normalbulbfront.jpg', '../Assets/LEDbulb/Normalbulbpacket.jpg', '../Assets/LEDbulb/Normalbulbpacket.jpg'],
      tableimgUrl: ['../Assets/Table/Bulbtable.JPG'] 
    },
    { 
      id: 63, 
      name: 'LED Bulb Mushroom Type', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs.', 
      imageUrls: ['../Assets/LEDbulb/Mushrumfront.jpg', '../Assets/LEDbulb/Mushrumpacket.jpg', '../Assets/LEDbulb/Mushrumpacket.jpg'],
      tableimgUrl: ['../Assets/Table/Bulbtable.JPG'] 
    },
    { 
      id: 64, 
      name: 'LED Bulb Bullet Type', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs.', 
      imageUrls: ['../Assets/LEDbulb/Bulletbulbfront.jpg', '../Assets/LEDbulb/Bulletbulbpacket.jpg', '../Assets/LEDbulb/Bulletbulbpacket.jpg'],
      tableimgUrl: ['../Assets/Table/Bulbtable.JPG']  
    },
    { 
      id: 65, 
      name: 'LED Bulb Bullet Type Heat Sink Body', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs.', 
      imageUrls: ['../Assets/LEDbulb/Heatsinkfront.jpg', '../Assets/LEDbulb/Heatsinkpacket.jpg', '../Assets/LEDbulb/Heatsinkpacket.jpg'],
      tableimgUrl: ['../Assets/Table/Bulbtable.JPG'] 
    },
     
    
    
  ];
    
    export default {
        products,
    }
  